
export default {
  props: {
    blogs: Array,
    title:{
      type:String,
    }
  },
  data() {
    return {
      scrollLeft: {
        reachedMax: true,
        icon: "/images/blog/arrow-disabled.png",
      },
      scrollRight: {
        reachedMax: false,
        icon: "/images/blog/arrow-enabled.png",
      },
    };
  },
  methods: {
    scroll(dir) {
      const blogList = this.$refs.blogList;
      if (blogList) {
        const maxScrollLeft = blogList.scrollWidth - blogList.clientWidth;
        dir === "right"
          ? (blogList.scrollLeft += window.innerWidth * 0.7)
          : (blogList.scrollLeft -= window.innerWidth * 0.7);
        setTimeout(() => {
          if (blogList.scrollLeft === 0) {
            this.scrollLeft.reachedMax = true;
            this.scrollLeft.icon = "/images/blog/arrow-disabled.png";
          } else {
            this.scrollLeft.reachedMax = false;
            this.scrollLeft.icon = "/images/blog/arrow-enabled.png";
          }

          if (blogList.scrollLeft === maxScrollLeft) {
            this.scrollRight.reachedMax = true;
            this.scrollRight.icon = "/images/blog/arrow-disabled.png";
          } else {
            this.scrollRight.reachedMax = false;
            this.scrollRight.icon = "/images/blog/arrow-enabled.png";
          }
        }, 500);
      }
    },
  },
};
